// Opt-in/out toggles for the automated spiritual emails (weekly digest + monthly recap PDF).
export const EmailPrefsPanel = ({ weeklyDigestEnabled, monthlyRecapEnabled, onToggleWeekly, onToggleMonthly }) => (
  <div className="mt-10 bg-white border border-[hsl(var(--border))] p-6 lg:p-8" data-testid="spiritual-weekly-digest-block">
    <div className="overline">Emails automáticos</div>
    <label className="mt-4 flex items-start gap-3 cursor-pointer">
      <input type="checkbox" checked={weeklyDigestEnabled} onChange={(e) => onToggleWeekly(e.target.checked)}
        className="mt-1 h-4 w-4" data-testid="spiritual-weekly-digest-toggle" />
      <span className="text-sm text-[hsl(var(--foreground))] leading-relaxed">
        <strong>Exame da Semana</strong> — todos os domingos às 21:00 (Europa/Lisboa).
        <span className="block text-xs text-[hsl(var(--muted-foreground))] mt-1">
          Pequeno resumo do cumprimento dos últimos 7 dias + uma pergunta para a oração.
        </span>
      </span>
    </label>
    <label className="mt-5 flex items-start gap-3 cursor-pointer">
      <input type="checkbox" checked={monthlyRecapEnabled} onChange={(e) => onToggleMonthly(e.target.checked)}
        className="mt-1 h-4 w-4" data-testid="spiritual-monthly-recap-toggle" />
      <span className="text-sm text-[hsl(var(--foreground))] leading-relaxed">
        <strong>Resumo do mês (PDF)</strong> — no dia 1 de cada mês, às 09:00.
        <span className="block text-xs text-[hsl(var(--muted-foreground))] mt-1">
          PDF com o exame particular, cumprimento por vínculo e as 4 perguntas das semanas anteriores.
        </span>
      </span>
    </label>
  </div>
);
